import get from 'lodash/get'
import React from 'react'
import set from 'lodash/set'
import { compose } from 'recompose'
import { connect } from 'react-redux'

import { ReduxState } from '../../types/redux'
import { modalDialogActions } from '../../redux'
import { ModalDialogConfiguration } from '../../redux/reducers/modalDialog/model'
import { errorHandler, IntlInterface, intl } from '../../hoc'
import ModalDialogComponent from '../../components/ModalDialog/ModalDialog'
import messages from '../../i18n'

interface ModalConfigurationsMap {
  [key: string]: ModalDialogConfiguration
}

interface Props extends IntlInterface {
  modalConfigurationsMap: ModalConfigurationsMap
  hideModalDialog: any
}

interface State {
  modalConfigurationsMap: {
    [key: string]: ModalDialogConfiguration
  }
}

export class ModalDialog extends React.Component<Props, State> {
  static getDerivedStateFromProps(props: Props, state: State) {
    const modalConfigurationsMap = { ...state.modalConfigurationsMap }
    Object.keys(modalConfigurationsMap).forEach((key: string) => {
      if (!props.modalConfigurationsMap[key]) {
        modalConfigurationsMap[key].show = false
      }
    })

    Object.keys(props.modalConfigurationsMap).forEach((key: string) => {
      modalConfigurationsMap[key] = { ...props.modalConfigurationsMap[key] }
    })

    return { modalConfigurationsMap }
  }

  state: State = {
    modalConfigurationsMap: {},
  }

  componentDidUpdate() {
    clearTimeout(this.timeoutIntervalRef)

    this.timeoutIntervalRef = setTimeout(this.clearHiddenModals, 1000)
    this.correctBodyOverflow()
  }

  onCloseBtnClick = (
    modalId: string,
    key: string,
    modalDialogConfiguration: ModalDialogConfiguration
  ) => {
    this.props.hideModalDialog(key)
    modalDialogConfiguration.closeButton &&
      modalDialogConfiguration.closeButton.onClick &&
      modalDialogConfiguration.closeButton.onClick(modalId)
  }

  onSecondBtnClick = (
    modalId: string,
    key: string,
    modalDialogConfiguration: ModalDialogConfiguration
  ) => {
    this.props.hideModalDialog(key)
    modalDialogConfiguration.secondButton &&
      modalDialogConfiguration.secondButton.onClick &&
      modalDialogConfiguration.secondButton.onClick(modalId)
  }

  correctBodyOverflow = () => {
    let somethingIsShown = false
    Object.keys(this.state.modalConfigurationsMap).some((key: string) => {
      if (this.state.modalConfigurationsMap[key].show) {
        somethingIsShown = true
        return true
      }
      return false
    })

    if (somethingIsShown && this.documentBodyOverflowBackup === null) {
      this.documentBodyOverflowBackup = get(document, 'body.style.overflow')
      set(document, 'body.style.overflow', 'hidden')
    } else if (!somethingIsShown && this.documentBodyOverflowBackup !== null) {
      set(document, 'body.style.overflow', this.documentBodyOverflowBackup)
      this.documentBodyOverflowBackup = null
    }
  }

  clearHiddenModals = () => {
    const modalConfigurationsMap: ModalConfigurationsMap = { ...this.state.modalConfigurationsMap }
    const keysCount = Object.keys(modalConfigurationsMap).length
    if (keysCount) {
      Object.keys(modalConfigurationsMap).forEach((key: string) => {
        if (!modalConfigurationsMap[key].show) {
          delete modalConfigurationsMap[key]
        }
      })

      const newKeysCount = Object.keys(modalConfigurationsMap).length

      if (keysCount !== newKeysCount) {
        this.setState({ modalConfigurationsMap })
      }
    }
  }

  documentBodyOverflowBackup = null
  timeoutIntervalRef: any = null

  render() {
    const keys = Object.keys(this.state.modalConfigurationsMap)

    return (
      <div className="Modals">
        {keys.map((key: string) => {
          const modalDialogConfiguration: ModalDialogConfiguration = this.state
            .modalConfigurationsMap[key]
          const closeButton: any = {
            onClick: (modalId: string) =>
              this.onCloseBtnClick(modalId, key, modalDialogConfiguration),
            text: this.props.translate(
              modalDialogConfiguration.closeButton?.text || messages.common.close
            ),
          }
          let secondButton: any = null
          if (modalDialogConfiguration.secondButton?.text) {
            secondButton = {
              onClick: (modalId: string) =>
                this.onSecondBtnClick(modalId, key, modalDialogConfiguration),
              text: modalDialogConfiguration.secondButton.text,
            }
          }

          return (
            <ModalDialogComponent
              key={key}
              {...modalDialogConfiguration}
              closeButton={closeButton}
              secondButton={secondButton}
            />
          )
        })}
      </div>
    )
  }
}

export default compose(
  errorHandler('containers/ModalDialog/ModalDialog.tsx'),
  connect(
    (state: ReduxState) => ({
      modalConfigurationsMap: state.modalDialog,
    }),
    {
      hideModalDialog: modalDialogActions.hideModalDialog,
    }
  ),
  intl
)(ModalDialog)
